import axios from "axios";
import { setInterceptors } from "./interceptor";

const createInstanceWithAuth = () => {
  const instance = axios.create({
    baseURL: "https://server.argong.ai/admin",
    // baseURL: "http://localhost:4000/admin",
    withCredentials: true,
  });
  return setInterceptors(instance);
};

const instanceAuth = createInstanceWithAuth();

export { instanceAuth };
